















import TextSection from '@/components/TextSection'

export default {
    name: 'ArticleTextSection'

    extends: TextSection
}
